<template>
  <v-dialog v-model="dialog" max-width="500px">
    <!-- <v-btn slot="activator" dark>Create Story</v-btn> -->
    <v-btn dark small round slot="activator">
      <v-icon>add</v-icon>
    </v-btn>
    <v-card>
      <form @submit.prevent="createStory" :close-on-content-click="false">
        <v-card-title style="padding-bottom:0">
          <span class="headline">{{ !story || newStory.id === '' ? 'New' : 'Edit' }} Story</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-sm style="padding-top:0px">
            <v-layout wrap>
              <template v-if="steps.step1 && !steps.step2">
                <v-flex xs12>
                  <v-text-field v-model="newStory.title" label="Project Title" :rules="[checkTitle]"
                                required></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="newStory.subtitle" label="Story Subtitle (optional)"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="newStory.organization" label="Organization (optional)"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="newStory.author" label="author (optional)"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field v-model="newStory.team" label="Team (optional)"></v-text-field>
                </v-flex>
              </template>
              <template v-if="steps.step2">
                <v-flex xs12>
                  <v-autocomplete v-model="experiences.experienceSelectedOption" @change="experienceChanged"
                                  :items="experiences.options"
                                  chips label="Device"></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete v-if="experiences.experienceSelectedOption === 'Mobile'"
                                  v-model="experiences.mobileExperienceSelectedOption"
                                  :items="experiences.mobileExperienceOptions"
                                  chips label="Experience"></v-autocomplete>
                  <v-autocomplete v-else-if="experiences.experienceSelectedOption === 'HMD'"
                                  v-model="experiences.hmdExperienceSelectedOption"
                                  :items="experiences.hmdExperienceOptions"
                                  chips label="Experience"></v-autocomplete>
                </v-flex>
                <v-flex
                  v-if="experiences.mobileExperienceSelectedOption === 'AR' || experiences.hmdExperienceSelectedOption === 'AR'"
                  xs12>
                  <v-autocomplete v-model="experiences.arSelectedOption" :items="experiences.arOptions"
                                  chips label="AR Options"></v-autocomplete>
                </v-flex>
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                  <img :src="newStory.imageUrl" height="150" v-if="newStory.imageUrl"/>
                  <v-text-field label="Select Image" @click='pickFile' v-model='newStory.imageName'
                                prepend-icon='attach_file'></v-text-field>
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                  >
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete v-model="newStory.topics" :items="['Late Night Show','Keyword Two','Keyword Three']"
                                  multiple chips label="keywords (optional)"></v-autocomplete>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green lighten-1" flat @click.native="dialog = false">Cancel</v-btn>
          <v-btn v-if="steps.step1 && !steps.step2" color="green lighten-1" flat type="submit" :disabled="isDisabled">Next</v-btn>
          <v-btn v-else color="green lighten-1" flat type="submit" :disabled="isDisabled">
            {{ !story || newStory.id === '' ? 'Create' : 'Update' }}
          </v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
// import {db, timelinesRef} from '../../firebaseDB'
import {db} from '../../firebaseDB'

let storyRef = db.ref('stories')
export default {
  name: 'create-story',
  firebase: {
    stories: storyRef
  },
  props: ['story', 'newText', 'newIcon'],
  data: () => ({
    dialog: false,
    user: null,
    experiences: {
      options: ['Mobile', 'HMD'],
      experienceSelectedOption: 'Mobile',
      mobileExperienceOptions: ['Screens', 'VR', 'AR'],
      mobileExperienceSelectedOption: 'AR',
      hmdExperienceOptions: ['VR', 'AR'],
      hmdExperienceSelectedOption: '',
      arOptions: ['Front Camera', 'Back Camera'],
      arSelectedOption: 'Back Camera'
    },
    steps: {
      step1: true,
      step2: false
    },
    newStory: {
      id: '',
      title: '',
      subtitle: '',
      organization: '',
      flex: 4,
      author: '',
      team: '',
      topics: [''],
      imageName: '',
      imageUrl: '',
      imageFile: '',
      owner: '',
      isStarred: false,
      date: new Date(Date.now()).toISOString().slice(0, 10),
      diagramData: {
        // { 'key': -3, 'category': 'Create', text: 'Create New', 'loc': '0 0' },
        // nodeDataArray: [{key: 0, title: 'START', category: 'Root', timelineId: ''}],
        nodeDataArray: [{key: 0, title: 'START', category: 'Root'}],
        linkDataArray: [],
        universalDataArray: [{
          key: 0, title: 'START', category: 'Root'
        }
        ]
      },
      nodeContentArray: ['']
    },
    exStory: false,
    isDisabled: false
  }),
  created () {
    this.user = this.$store.state.user
    this.allStories = this.$store.state.stories
  },
  watch: {
    story: {
      handler: function (value) {
        if (value) {
          this.dialog = true
          this.newStory = this.story
          if (this.newStory.hasOwnProperty('experience')) {
            if (this.newStory.experience.device) {
              this.experiences.experienceSelectedOption = this.newStory.experience.device
            }
            if (this.newStory.experience.type) {
              if (this.newStory.experience.device === 'Mobile') {
                this.experiences.hmdExperienceSelectedOption = ''
                this.experiences.mobileExperienceSelectedOption = this.newStory.experience.type
              } else if (this.newStory.experience.device === 'HMD') {
                this.experiences.mobileExperienceSelectedOption = ''
                this.experiences.hmdExperienceSelectedOption = this.newStory.experience.type
              }
            }
            if (this.newStory.experience.default) {
              this.experiences.arSelectedOption = this.newStory.experience.default
            }
          }
        } else {
          this.newStory.author = this.$store.state.profile.name
        }
      }
    },
    dialog: function (value) {
      this.user = this.$store.state.user
      if (!value) {
        Object.assign(this.$data, this.$options.data.call(this))
        this.$emit('emptyEditStory')
      }
    }
  },
  mounted () {
    alert('Test story')
  },
  computed: {
    checkTitle () {
      // this.stories = this.stories.filter(story => story.owner === this.user)
      this.isDisabled = false
      if (!this.newStory.title.length) {
        this.isDisabled = true
        return 'Project title has to be at least 1 characters'
      } else if (this.stories.length > 0 && this.stories.find(value => value.title === this.newStory.title && value['.key'] !== this.newStory.id)) {
        this.isDisabled = true
        return 'The project title already exists'
      }
      return true
    }
  },
  // watch: {
  //   'newStory.diagramData.nodeDataArray': {
  //     handler: function (val, oldVal) {
  //       console.log('a thing changed')
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    createStory () {
      let storyKey
      if (this.steps.step1 && this.steps.step2) {
        this.newStory.experience = {}
        this.newStory.experience.device = this.experiences.experienceSelectedOption
        this.newStory.experience.type = this.experiences.experienceSelectedOption === 'Mobile' ? this.experiences.mobileExperienceSelectedOption : this.experiences.hmdExperienceSelectedOption
        this.newStory.experience.default = this.experiences.mobileExperienceSelectedOption === 'AR' || this.experiences.hmdExperienceSelectedOption === 'AR' ? this.experiences.arSelectedOption : null
      }
      if (this.newStory.id) {
        this.newStory.updated_at = new Date(Date.now()).toISOString().slice(0, 10)
        db.ref()
          .child(`stories/${this.newStory.id}`)
          .update(this.newStory)
          .then(() => {
            storyKey = this.newStory.id
          })
      } else {
        this.newStory.owner = this.user.email
        if (this.newStory.imageUrl === '') {
          this.newStory.imageUrl = 
          //'https://images.pexels.com/photos/860538/pexels-photo-860538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260'
          "https://firebasestorage.googleapis.com/v0/b/ibegoo-dev.appspot.com/o/new-story.png?alt=media&token=3a71f3b3-a899-423b-8c4e-8684d4b7a793"

        }
        if (this.newStory.author === '') {
          this.newStory.author = this.user.email
        }
        const storiesRef = db.ref().child('stories')
        // add story to `stories` collection in db with ref to timeline
        // let timelineMessageRef = timelinesRef.push()
        // New Stories start with one scene
        // this.newStory.diagramData.nodeDataArray[0].timelineId = timelineMessageRef.key
        this.newStory.user_id = this.$store.state.user.id
        storyKey = storiesRef.push(this.newStory).key
        this.newStory.id = storyKey
        // timelineMessageRef.set({storyId: storyKey})
        this.$store.dispatch('listUserStories')
      }
      if (this.steps.step1 && this.steps.step2) {
        this.dialog = false
        this.$router.push({name: 'storyEditView', params: {title: this.newStory.title}, query: {id: storyKey}})
      } else {
        this.steps.step2 = true
      }
      // this.newStory = {
      //   title: '',
      //   subtitle: '',
      //   flex: 4,
      //   author: '',
      //   team: '',
      //   topics: [''],
      //   imageName: '',
      //   imageUrl: '',
      //   imageFile: '',
      //   owner: '',
      //   diagramData: {
      //     nodeDataArray: [{key: 1, text: 'Root', color: 'White'}],
      //     linkDataArray: [{null: ''}]
      //   },
      //   nodeContentArray: ['']
      // }
    },
    pickFile () {
      this.$refs.image.click()
    },
    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.newStory.imageName = files[0].name
        if (this.newStory.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.newStory.imageUrl = fr.result
          this.newStory.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.newStory.imageName = ''
        this.newStory.imageFile = ''
        this.newStory.imageUrl = ''
      }
    },
    experienceChanged: function () {
      this.experiences.mobileExperienceSelectedOption = ''
      this.experiences.hmdExperienceSelectedOption = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/story-list-view/createStory.vue